import styled from 'styled-components';

export const NoteComponentStyle = styled.div`

  padding: 10px;
  gap: 10px;
  border: 2px solid #342c24;
  width: 100%;
  height: 100%;
  left: 16px;
  top: 76px;
  background: #0c3255;
  .header {
    display: flex;
    justify-content: space-between;
    .btn-delete {
        cursor: pointer;
    } 
    .title {
      font-size: 16px;
      font-weight: 700;
      line-height: 28px;
      text-align: left;
    }
    .wrapper-content {
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      text-align: left;
    }
  }
`;
